export const IMPERSONATED_CLIENT_COOKIE = 'impersonatedClient';
export const LOGOUT_COOKIE = 'doLogout';
export const JWT_TOKEN_COOKIE_KEY = 'jwtRent';
export const REFRESH_TOKEN_COOKIE_KEY = 'refreshTokenRent';
export const EXPIRES_IN_COOKIE_KEY = 'expiresInRent';
export const PROJECT_ID_COOKIE_KEY = 'project_id';
export const CLIENT_ID_RENT_COOKIE = 'clientIdRent';

export const HOSTNAME_QUERY_PARAM_KEY = 'hostname';
export const PROJECT_ID_PARAM_KEY = 'projectID';
export const LOCALE_PARAM_KEY = 'locale';
